var React = require('react');

function Si (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#0052b4","d":"M0 167l253.8-19.3L512 167v178l-254.9 32.3L0 345z","key":0}),React.createElement("path",{"fill":"#eee","d":"M0 0h512v167H0z","key":1}),React.createElement("path",{"fill":"#d80027","d":"M0 345h512v167H0z","key":2}),React.createElement("path",{"fill":"#0052b4","d":"M222.7 167v-66.8H89V167l67 82.6z","key":3}),React.createElement("path",{"fill":"#eee","d":"M89 167v22.2c0 51.1 66.8 66.8 66.8 66.8s66.8-15.7 66.8-66.8V167l-22.3 22.2-44.5-33.4-44.5 33.4z","key":4})])]);
}

Si.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Si;

Si.default = Si;
